import Big from 'big.js';

export const multiply = (a, b) => {
    return Big(a).times(Big(b)).toNumber();
}

export const divide = (a, b) => {
    return Big(a).div(Big(b)).toNumber();
}